import Nullstack from 'nullstack';
export default function IconLetterSpacing({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-letter-spacing",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
  }), "   ", Nullstack.element("path", {
    d: "M13 4l3 8l3 -8"
  }), "   ", Nullstack.element("path", {
    d: "M5 18h14"
  }), "   ", Nullstack.element("path", {
    d: "M17 20l2 -2l-2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M7 16l-2 2l2 2"
  }), " ");
}